import React from "react";
import { ArrowLeft, Check, AlertCircle } from "lucide-react";

const SERVICE_LABELS = { interior: "Interior Reset", exterior: "Exterior Car Wash", full: "Full Service Package" };

export default function EstimateStep({ booking, onNext, onBack }) {
  if (!booking) return null;
  const { price, car, address } = booking;
  const svc = SERVICE_LABELS[booking.service || "full"] || "Full Service Package";

  return (
    <div data-testid="step-estimate">
      <p className="overline mb-6">Step 05 · Your Estimate</p>
      <h2 className="font-serif text-4xl sm:text-5xl tracking-tighter leading-[0.95] mb-8">
        Here is what
        <br />
        <span className="gold-gradient-text italic">we estimate.</span>
      </h2>

      <div className="card-luxe p-8 mb-6">
        <p className="overline mb-2">Estimated Total</p>
        <div className="flex items-baseline gap-3 mb-4">
          <span className="font-serif text-7xl gold-gradient-text">${price.estimate}</span>
          <span className="text-white/40 text-lg">USD</span>
        </div>

        <div className="space-y-2 mt-6 text-sm">
          <Row label="Base service" value={`$${price.base}`} />
          {price.surcharge > 0 && (
            <Row label="Larger-vehicle surcharge" value={`+$${price.surcharge}`} />
          )}
          {price.condition_uplift > 0 && (
            <Row label="Condition uplift" value={`+$${price.condition_uplift}`} />
          )}
          <div className="spec-divider my-3"></div>
          <Row label="Minimum charge" value={`$${price.minimum}`} muted />
        </div>
      </div>

      <div className="tile-spec p-5 mb-6 flex gap-3 items-start">
        <AlertCircle size={18} className="text-gold mt-0.5 shrink-0" />
        <p className="text-sm text-white/70 leading-relaxed">
          This estimate is not always the final amount. The actual price may change slightly based on the vehicle's condition on the day of service.
        </p>
      </div>

      <div className="space-y-3 mb-8 text-sm text-white/60">
        <div className="flex items-start gap-3">
          <Check size={16} className="text-gold mt-0.5 shrink-0" />
          <span>
            <span className="text-white">{car.year || ""} {car.make} {car.model}</span>{" "}
            <span className="text-white/40">· {car.body_type.replace("-", " ")}</span>
          </span>
        </div>
        <div className="flex items-start gap-3">
          <Check size={16} className="text-gold mt-0.5 shrink-0" />
          <span className="text-white/80">{address.formatted}</span>
        </div>
        <div className="flex items-start gap-3">
          <Check size={16} className="text-gold mt-0.5 shrink-0" />
          <span className="text-white capitalize">{booking.condition} condition</span>
        </div>
        <div className="flex items-start gap-3">
          <Check size={16} className="text-gold mt-0.5 shrink-0" />
          <span className="text-white">{svc}</span>
        </div>
      </div>

      <div className="flex justify-between">
        <button className="btn-secondary" onClick={onBack} data-testid="estimate-back-button">
          <ArrowLeft size={14} /> Edit Details
        </button>
        <button className="btn-primary" onClick={onNext} data-testid="estimate-confirm-button">
          Confirm Booking
          <Check size={14} />
        </button>
      </div>
    </div>
  );
}

function Row({ label, value, muted }) {
  return (
    <div className="flex justify-between">
      <span className={muted ? "text-white/40" : "text-white/60"}>{label}</span>
      <span className={muted ? "text-white/60 font-mono" : "text-white font-mono"}>{value}</span>
    </div>
  );
}
